module.exports = __webpack_public_path__ + "img/HeadlineBanner.c86abebd.jpg";